import { render } from "./GenerationStats.vue?vue&type=template&id=e685017c&scoped=true"
import script from "./GenerationStats.vue?vue&type=script&lang=js"
export * from "./GenerationStats.vue?vue&type=script&lang=js"

import "./GenerationStats.vue?vue&type=style&index=0&id=e685017c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e685017c"]])

export default __exports__